module.exports = __webpack_public_path__ + "fonts/CalibreLightItalic.cd88d6a7.woff";